function isReactElement(node) {
    return node instanceof Object;
}
export default isReactElement;
